const tenantACEntries = (tenantACEntries = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_TENANT_AC_ENTRIES':
      return action.payload
    default:
      return tenantACEntries
  }
}
export default tenantACEntries
